export default __webpack_public_path__ + "static/media/bell-pepper-menu-1.dc2001b7.png";